import { Button } from '@radix-ui/themes'

interface PolicyFooterProps {
  selectedPage: string
  setSelectedPage: (page: string) => void
  onNext?: () => void
  onPrevious?: () => void
  disableNext?: boolean
}

const stepOrder = ['details', 'rules', 'integration', 'groups', 'summary']

function PolicyFooter({ selectedPage, setSelectedPage, onNext, onPrevious, disableNext = false }: PolicyFooterProps) {
  const currentIndex = stepOrder.indexOf(selectedPage)

  const handlePrevious = () => {
    if (onPrevious) onPrevious()
    else if (currentIndex > 0) setSelectedPage(stepOrder[currentIndex - 1])
  }

  const handleNext = () => {
    if (onNext) onNext()
    else if (currentIndex < stepOrder.length - 1) setSelectedPage(stepOrder[currentIndex + 1])
  }

  return (
    <div className="flex justify-end w-[calc(100%-209px)] px-4 py-2 bg-white border-t border-mainBorder fixed bottom-0 right-0">
      <button
        className="h-7 bg-white text-xs text-textTertiary border border-mainBorder rounded px-3 font-medium cursor-pointer mr-2.5 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handlePrevious}
        disabled={currentIndex === 0}
      >
        Previous Step
      </button>
      <Button
        className="h-7 bg-mainPurple text-xs text-white hover:bg-tertiaryPurple active:active:bg-tertiaryPurple cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed"
        onClick={handleNext}
        disabled={disableNext}
      >
        {currentIndex === stepOrder.length - 1 ? 'Create Policy' : 'Next Step'}
      </Button>
    </div>
  )
}

export default PolicyFooter
